import React from 'react';
import { Link } from 'react-router-dom';
import { Upgrade } from '@intigral/ui';
import { Button } from '@intigral/shared/components/Button';
import h from '../../helpers/common';
import { __ } from '../../translations';
import { Text, FlexWrapper } from '@intigral/shared';
import { FlexChild } from '@intigral/shared/lib/components/FlexWrapper';
import withResponsiveStyles from '@intigral/shared/components/hocs/ResponiseStyles/withResponsiveStyles';
import { showUpdatePayment } from '@intigral/utils/lib/user/ui';
import { STORE_NAME } from '../../config/constants';

export const UpgradedBannerFail = (props) => {
    const { content: upgradedBannerFailFields } = props;
    const language = h.getLang();

    const user = h.getStore(STORE_NAME.USER) || {};

    const ButtonStyle = withResponsiveStyles(Button);

    const background = upgradedBannerFailFields?.background?.[language];
    const logo = upgradedBannerFailFields?.logo?.[language];
    const title = upgradedBannerFailFields?.title?.[language];
    const link = upgradedBannerFailFields?.link?.[language];
    const linkText = upgradedBannerFailFields?.link_text?.[language];
    const caption = upgradedBannerFailFields?.caption?.[language];

    const [beforeLogo, afterLogo] = __(title).split('{logo}');

    // Render the Banner
    return (
        showUpdatePayment(user) && (
            <Upgrade picture={background} variant={'modal'} id={'upgraded-banner-fail'}>
                <FlexWrapper direction="column" gap="3x" padding="6x">
                    <FlexWrapper
                        direction={{ default: 'column', md: 'row' }}
                        justifyContent="center"
                        alignItems="center"
                        gap="2x"
                    >
                        <Text as="p" size={{ default: '18', md: '22' }}>
                            {beforeLogo}
                        </Text>
                        {__(title).includes('{logo}') && (
                            <FlexChild alignSelf="center">
                                <img src={logo} width="79" alt="" />
                            </FlexChild>
                        )}
                        <Text as="p" size={{ default: '18', md: '22' }}>
                            {afterLogo}
                        </Text>
                    </FlexWrapper>
                    <ButtonStyle placement="center">
                        <a href={link}>{__(linkText)}</a>
                    </ButtonStyle>
                    <Text as="p" color="gray">
                        {__(caption)}
                    </Text>
                </FlexWrapper>
            </Upgrade>
        )
    );
};
